export default __webpack_public_path__ + "static/media/Microsoft-gray.bf290462.png";